import { render, staticRenderFns } from "./detailComBasicInfo.vue?vue&type=template&id=552c995f&scoped=true&"
import script from "./detailComBasicInfo.vue?vue&type=script&lang=js&"
export * from "./detailComBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./detailComBasicInfo.vue?vue&type=style&index=0&id=552c995f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552c995f",
  null
  
)

export default component.exports